import React from 'react'
import { StyleSheet, TextInput, TextInputProps, View } from 'react-native'
import { DS } from '@/design-system'

interface FormTextInputProps
  extends Pick<TextInputProps, 'value' | 'onChangeText' | 'placeholder' | 'keyboardType' | 'onBlur'> {
  label: string
  error?: string
  hideErrorText?: boolean
}

export function FormTextInput({
  label,
  value,
  onChangeText,
  placeholder,
  keyboardType,
  error,
  hideErrorText,
  onBlur
}: FormTextInputProps) {
  return (
    <View style={styles.container}>
      <DS.Text variant="Body Medium/Regular" style={styles.label}>
        {label}
      </DS.Text>
      <TextInput
        value={value}
        onChangeText={onChangeText}
        onBlur={onBlur}
        placeholder={placeholder}
        keyboardType={keyboardType}
        placeholderTextColor={DS.palette['Brand/Dark Grey']}
        style={[styles.input, error ? styles.inputError : null]}
      />
      {error && !hideErrorText ? (
        <DS.Text variant="Caption/Regular" style={styles.errorText}>
          {error}
        </DS.Text>
      ) : null}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    gap: 6
  },
  label: {
    color: DS.palette['Global/Black']
  },
  input: {
    height: 48,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    paddingHorizontal: 12,
    backgroundColor: DS.palette['Global/White'],
    color: DS.palette['Global/Black'],
    fontSize: 16
  },
  inputError: {
    borderColor: DS.palette['Utility/Error']
  },
  errorText: {
    color: DS.palette['Utility/Error'],
    fontSize: 16
  }
})
